export enum UserType {
	Admin = 2,
	Worker = 3,
	Patient = 8,
	Contact = 5
}
